export default __webpack_public_path__ + "img/21e3b7622965dacd13bc9b3f84b55b25.png";